/**
 * Payment Service
 * Handles payment operations
 */

import { httpsCallable } from 'firebase/functions';
import {
  collection,
  query,
  where,
  orderBy,
  getDocs,
  onSnapshot,
} from 'firebase/firestore';
import { db, functions } from './firebase';

/**
 * Process payment (via Cloud Function)
 */
export const processPayment = async (paymentData) => {
  try {
    const processPaymentFn = httpsCallable(functions, 'processPayment');
    const result = await processPaymentFn(paymentData);
    return result.data;
  } catch (error) {
    console.error('Error processing payment:', error);
    throw error;
  }
};

/**
 * Get payment history for user
 */
export const getPayments = async (userId, filters = {}) => {
  try {
    let q = query(
      collection(db, 'payments'),
      where('userId', '==', userId),
      orderBy('createdAt', 'desc')
    );

    if (filters.status) {
      q = query(q, where('status', '==', filters.status));
    }

    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error getting payments:', error);
    throw error;
  }
};

/**
 * Subscribe to payments
 */
export const subscribeToPayments = (userId, callback) => {
  const q = query(
    collection(db, 'payments'),
    where('userId', '==', userId),
    orderBy('createdAt', 'desc')
  );

  return onSnapshot(q, (snapshot) => {
    const payments = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    callback(payments);
  });
};

/**
 * Generate idempotency key for payment
 */
export const generateIdempotencyKey = () => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 15);
  return `payment_${timestamp}_${random}`;
};
